const variantStyles = {
    green: 'bg-[#f0fdf4] border-[rgba(0,166,62,0.2)] text-[#008236]',
    blue: 'bg-[#eff6ff] border-[rgba(20,71,230,0.1)] text-[#1447e6]',
    purple: 'bg-[#faf5ff] border-[rgba(130,0,219,0.1)] text-[#8200db]',
    yellow: 'bg-[#fefce8] border-[rgba(208,135,0,0.2)] text-[#894b00]',
    neutral: 'bg-neutral-50 border-gray-500/10 text-slate-600',
};

export type PillBadgeVariant = keyof typeof variantStyles;

interface PillBadgeProps {
    label: string;
    variant?: PillBadgeVariant;
    className?: string;
}

const PillBadge = ({ label, variant = 'green', className }: PillBadgeProps) => (
    <span
        className={`inline-flex items-center rounded-md border border-solid px-1.5 py-0.5 text-xs leading-[1.5] font-medium ${variantStyles[variant]} ${className ?? ''}`}
    >
        {label}
    </span>
);

export default PillBadge;
